import * as ApiClientCommunication from './ApiClient/index';

import {ArgValidator, ArgValidationError, ArgValidationErrorTypes} from './Utils/ArgValidator';
import {ArrayUtils} from './Utils/ArrayUtils';
import {StringUtils} from './Utils/StringUtils';
import {Utils} from './Utils/Utils';
import {Logger} from './Utils/Logger';
import {FileUtils} from './Utils/FileUtils';
import {UriHelper} from './Utils/UriHelper';
import {StringsFactory, StringsFactoryInitializeOptions, StringsInitLoadCallback, StringsLoadCompleteCallback} from './Utils/StringsFactory';
import * as CommonTypes from './Utils/CommonTypes';
import {PromiseUtils} from './Utils/PromiseUtils';
import {HtmlUtils} from './Utils/HtmlUtils';
import {NumberUtils} from './Utils/NumberUtils';
import {KeyboardUtils} from './Utils/KeyboardUtils';
import {ObjectUtils} from './Utils/ObjectUtils';
import {DateUtils} from './Utils/DateUtils';
import {BrowserUtils} from './Utils/BrowserUtils';

import {libraryInitialize} from './bootstrap';

import {EngineComponentFactory, engineComponent} from './Component/EngineComponentFactory';

import {Preloader} from './Preloader/Preloader';
import {EmptyResourceLoader} from './Preloader/EmptyResourceLoader';
import {PreloaderInfo} from './Preloader/Types/PreloaderInfo';
import {PreloaderProviderBase} from './Preloader/Types/PreloaderProviderBase';
import {PreloaderOptions} from './Preloader/Types/PreloaderOptions';
import {PreloaderResourceLoader} from './Preloader/Types/PreloaderResourceLoader';
import {PreloaderResourceItem} from './Preloader/Types/PreloaderResourceItem';

import * as lodash from 'lodash';
import * as keyboardjs from 'keyboardjs';
import * as bluebird from 'bluebird';

import {createEventEmmiter, EventListenerFunction, IEventEmitter} from './Utils/EventEmitterBase';
import {EventEmitterCached} from './Utils/EventEmitterCached';

const isBrowser = typeof window !== 'undefined';

if (isBrowser) {
    window['Promise'] = Promise;
    window['URI'] = URI;
}

export {
    ApiClientCommunication,

    ArgValidator,
    ArrayUtils,
    StringUtils,
    Utils,
    FileUtils,
    Logger,
    UriHelper,
    ArgValidationError,
    ArgValidationErrorTypes,
    CommonTypes,
    StringsFactory, StringsFactoryInitializeOptions, StringsInitLoadCallback, StringsLoadCompleteCallback,
    PromiseUtils,
    HtmlUtils,
    NumberUtils,
    KeyboardUtils,
    ObjectUtils,
    DateUtils,
    BrowserUtils,

    EngineComponentFactory,
    engineComponent,

    Preloader,
    EmptyResourceLoader,
    PreloaderInfo,
    PreloaderProviderBase,
    PreloaderOptions,
    PreloaderResourceLoader,
    PreloaderResourceItem,

    createEventEmmiter, EventListenerFunction, IEventEmitter,
    EventEmitterCached,

    lodash,
    keyboardjs,
    bluebird,

    libraryInitialize
}


/** WEBPACK FOOTER **
 ** ./Engine/index.prod.ts
 **/